import { apiFetch } from './apiClient';



/* ── Grupos ── */
export const listarGrupos     = () => apiFetch('/grupos-fluxo');
export const criarGrupo       = (dados) => apiFetch('/grupos-fluxo', { method: 'POST', body: JSON.stringify(dados) });
export const atualizarGrupo   = (id, dados) => apiFetch(`/grupos-fluxo/${id}`, { method: 'PATCH', body: JSON.stringify(dados) });
export const excluirGrupo     = (id) => apiFetch(`/grupos-fluxo/${id}`, { method: 'DELETE' });

/* ── Linha do tempo (colunas + itens) ── */
export const listarColunasDoGrupo = (grupoId) => apiFetch(`/grupos-fluxo/${grupoId}/colunas`);
export const criarColuna          = (dados) => apiFetch('/grupos-fluxo-colunas', { method: 'POST', body: JSON.stringify(dados) });
export const atualizarColuna      = (id, dados) => apiFetch(`/grupos-fluxo-colunas/${id}`, { method: 'PATCH', body: JSON.stringify(dados) });
export const excluirColuna        = (id) => apiFetch(`/grupos-fluxo-colunas/${id}`, { method: 'DELETE' });
export const criarItem            = (colunaId, dados) => apiFetch(`/grupos-fluxo-colunas/${colunaId}/itens`, { method: 'POST', body: JSON.stringify(dados) });
export const atualizarItem        = (id, dados) => apiFetch(`/grupos-fluxo-itens/${id}`, { method: 'PATCH', body: JSON.stringify(dados) });
export const excluirItem          = (id) => apiFetch(`/grupos-fluxo-itens/${id}`, { method: 'DELETE' });

/* ── Clientes do grupo ── */
export const listarClientesDoGrupo   = (grupoId) => apiFetch(`/grupos-fluxo/${grupoId}/clientes`);
export const vincularClientesAoGrupo = (grupoId, clienteIds) => apiFetch(`/grupos-fluxo/${grupoId}/clientes`, { method: 'POST', body: JSON.stringify({ cliente_ids: clienteIds }) });
export const desvincularClienteDoGrupo = (grupoId, clienteId) => apiFetch(`/grupos-fluxo/${grupoId}/clientes/${clienteId}`, { method: 'DELETE' });

/* ── Aplicação/vínculo Nibo por cliente x coluna ── */
export const definirVinculoClienteColuna = (colunaId, clienteId, dados) =>
  apiFetch(`/grupos-fluxo-colunas/${colunaId}/clientes/${clienteId}`, { method: 'PATCH', body: JSON.stringify(dados) });

/* ── Execução (a grade mensal) ── */
export const buscarExecucao = (grupoId, competencia) => apiFetch(`/grupos-fluxo/${grupoId}/execucao?competencia=${encodeURIComponent(competencia)}`);
export const marcarExecucao = (grupoId, dados) => apiFetch(`/grupos-fluxo/${grupoId}/execucao`, { method: 'PATCH', body: JSON.stringify(dados) });
